import script from "./insights-floating-sidepane.vue?vue&type=script&setup=true&lang=ts"
export * from "./insights-floating-sidepane.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__